/* eslint no-console: ["error", { allow: ["warn", "error"] }] */

'use strict';

const STORAGE_KEY = 'rp_breadcrumbs_stored';

const breadcrumbs = {};

/**
 * Escape HTML
 * @param {string} text
 * @returns {string}
 */
breadcrumbs.escapeHtml = function(text) {
	const div = document.createElement('div');
	div.textContent = text;
	return div.innerHTML;
};

/**
 * @returns {Array<{href: string, caption: string}>}
 */
breadcrumbs.readBreadcrumbsFromDOM = function() {
	const $default = rp$('.breadcrumbs-default');
	if (!$default.length) return [];

	const items = [];
	$default.find('a').each(function() {
		const $link = rp$(this);
		items.push({
			href: $link.attr('href') || '',
			caption: $link.text().trim()
		});
	});

	return items;
};

/**
 * @param {Array<Object>} data
 */
breadcrumbs.saveBreadcrumbs = function(data) {
	try {
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
	} catch (e) {
		//Silent error handling
	}
};

/**
 * @returns {Array<Object>|null}
 */
breadcrumbs.getStoredBreadcrumbs = function() {
	try {
		const raw = sessionStorage.getItem(STORAGE_KEY);
		return raw ? JSON.parse(raw) : null;
	} catch (e) {
		return null;
	}
};

/**
 * @returns {void}
 */
breadcrumbs.removeStoredBreadcrumbs = function() {
	try {
		sessionStorage.removeItem(STORAGE_KEY);
	} catch (e) {
		// Silent error handling
	}
};

/**
 * @param {string} pattern
 * @param {Object<string,string>} allValues
 * @returns {string}
 */
breadcrumbs.buildCaptionFromPattern = function(pattern, allValues) {
	if (!pattern) return '';

	let caption = pattern;
	Object.keys(allValues || {}).forEach((key) => {
		const value = allValues[key];
		if (value === null || value === undefined || value === '') {
			caption = caption.replace(
				new RegExp(`\\s*"?\\{${key}\\}"?`, 'g'),
				''
			);
		} else {
			caption = caption.replace(
				new RegExp(`\\{${key}\\}`, 'g'),
				value
			);
		}
	});

	return caption.replace(/\s{2,}/g, ' ').trim();
};

/**
 * @param {Array<{href: string, caption: string}>} breadcrumbsArray
 */
breadcrumbs.renderStoredBreadcrumbs = function(breadcrumbsArray) {
	const $dynamic = rp$('.breadcrumbs-dynamic');
	const $default = rp$('.breadcrumbs-default');
	if (!$dynamic.length || !breadcrumbsArray.length) return;

	let html = '';

	breadcrumbsArray.forEach((crumb, index) => {
		const isLast = index === breadcrumbsArray.length - 1;
		html += `<a href="${breadcrumbs.escapeHtml(crumb.href)}" ${isLast ? 'class="tail"' : ''}>`;
		html += breadcrumbs.escapeHtml(crumb.caption);
		html += '</a>';

		if (!isLast) {
			html += ' <i class="fa fa-angle-right"></i> ';
		}
	});

	$dynamic.html(html);
	$default.hide();
	$dynamic.show();
};

/**
 * @param {string} data
 * @returns {Object}
 */
breadcrumbs.convertToObject = function(data) {
	try {
		return typeof data === 'string' ? JSON.parse(data) : data;
	} catch (e) {
		return {};
	}
};

/**
 * @returns {void}
 */
breadcrumbs.processBreadcrumbsStorage = function() {
	const $container = rp$('.page-bread-crumbs');
	if (!$container.length) 
		return;

	const $dynamic = rp$('.breadcrumbs-dynamic');
	const $default = rp$('.breadcrumbs-default');
	try {
		let action = $container.data('breadcrumb-storage-action');
		if (!action || action === 'null' || action === null) {
			breadcrumbs.removeStoredBreadcrumbs();
			$container.removeAttr('hidden');
			$dynamic.empty().hide();
			$default.show();
			return;
		}

		let storageData = {};
		const storageDataStr = $container.data('breadcrumb-storage-data');
		if (storageDataStr && storageDataStr !== 'null') {
			storageData = typeof storageDataStr === 'string' ? breadcrumbs.convertToObject(storageDataStr) : storageDataStr;
		}

		const actions = {
			save: () => {
				const domBreadcrumbs = breadcrumbs.readBreadcrumbsFromDOM();
				if (!domBreadcrumbs.length || !storageData.pattern) 
					return;

				const toSave = {
					pattern: storageData.pattern ?? '',
					values: storageData.pattern_values ?? {},
					position: storageData.position ?? 0,
					items: domBreadcrumbs.map((crumb) => ({
						href: crumb.href,
						caption: crumb.caption
					}))
				};
				breadcrumbs.saveBreadcrumbs(toSave);
			},

			show: () => {
				const stored = breadcrumbs.getStoredBreadcrumbs();
				if (!stored || !stored.items?.length) 
					return;

				stored.values = { ...stored.values, ...storageData.pattern_values };
				const rebuiltCaption = breadcrumbs.buildCaptionFromPattern(stored.pattern, stored.values);
				const crumbs = stored.items.map((crumb, index) => ({
					href: crumb.href,
					caption: stored.position === index + 1 ? rebuiltCaption : crumb.caption
				}));

				breadcrumbs.renderStoredBreadcrumbs(crumbs);
				breadcrumbs.saveBreadcrumbs(stored);
			}
		};
		
		actions[action]();
		$container.removeAttr('hidden');
	} catch (e) {
		breadcrumbs.removeStoredBreadcrumbs();
		$container.removeAttr('hidden');
		$dynamic.empty().hide();
		$default.show();
	}
};

breadcrumbs.initBreadcrumbsStorage = function() {
	breadcrumbs.processBreadcrumbsStorage();
};

const onReady = require('public/js/lib/on-ready');
onReady({
	rp$, window,
	label: 'breadcrumbs',
	fn: breadcrumbs.initBreadcrumbsStorage
});

module.exports = breadcrumbs;
